import { Component, OnInit } from '@angular/core';
import { PermissionStore } from '@app/@core/store/permission.store';
import { MenuItem } from 'primeng/api';
@Component({
  standalone: false,
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {
  items: MenuItem[] = [];
  activeItem!: MenuItem;
  constructor(private permissionStore: PermissionStore) {
    // This is intentional
  }

  ngOnInit(): void {
    const permissions = this.permissionStore.state;
    this.items = [
      {
        label: 'Data Source',
        routerLink: ['data-source'],
        visible: permissions.SETTINGS_DATA_SRC,
      },
      // {
      //   label: 'Masters',
      //   routerLink: ['masters'],
      //   visible: permissions.SETTINGS_MAS,
      //   badge: 'SETTINGS_MAS'
      // },
      {
        label: 'Login Page',
        routerLink: ['config-settings'],
        visible: permissions.SETTINGS_CONFIG,
      },
      {
        label: 'Platform',
        routerLink: ['platform-settings'],
        visible: permissions.SETTINGS_PLATFORM,
      },
      {
        label: 'Global Search',
        routerLink: ['global-search'],
        visible: permissions.GLOBAL_SEARCH,
      }
    ];
    this.activeItem = this.items[0];
  }
}
